export default __webpack_public_path__ + "ide-project-images/55e52ba118eb9dd7489c7731cd7d4738.png";